'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import UITab from 'UIComponents/nav/UITab';
/**
 * High Order Component for casting components as UITab components
 */

export default function castToUITabs(WrappedComponent) {
  class TabLikeComponent extends Component {
    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props));
    }

  }

  TabLikeComponent.propTypes = UITab.propTypes;
  TabLikeComponent.defaultProps = Object.assign({}, UITab.defaultProps, {
    title: /*#__PURE__*/_jsx("div", {})
  });
  return TabLikeComponent;
}